module.exports = __webpack_public_path__ + "media/images/favicons/apple-icon-152x152-6fe43d658fa02f3ab1e8c3e9404cbda3.png";